import { FC } from 'react';

interface IconCrownProps {
    className?: string;
    fill?: boolean;
    duotone?: boolean;
}

const IconCrown: FC<IconCrownProps> = ({ className, fill, duotone = true }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path opacity={duotone ? "0.5" : "1"} d="M2 12L5 8L9 12L12 5L15 12L19 8L22 12V20H2V12Z" fill={fill ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default IconCrown;
